import React from "react"
// import { Loading } from "../../components/ui/loading"
import { useAuth } from "../../contexts/AuthContext"
import DashboardPage from "./Dashboard"

const AppPage = () => {
  const { isLoading } = useAuth()

  if (isLoading) {
    return <div>loading</div>
  }

  return <DashboardPage />
}

export default AppPage
